import { render, staticRenderFns } from "./SiftYear.vue?vue&type=template&id=b854bf6c&scoped=true&"
import script from "./SiftYear.vue?vue&type=script&lang=js&"
export * from "./SiftYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b854bf6c",
  null
  
)

export default component.exports